export const getBasename = (path: string): string => {
  // Remover parâmetros de query se existirem
  const cleanPath = path.split('?')[0];
  // Pegar a última parte do caminho após a última barra
  return cleanPath.split('/').pop() || '';
}; 